
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33798',
  depVersions: {
  "documents-public-ui": "static-1.33798",
  "client-types": "static-1.443",
  "documents-lib": "static-1.33803",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1839",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.98",
  "hs-promise-utils": "static-1.5309",
  "hs-test-utils": "static-1.7703",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1786",
  "HubStyleTokens": "static-2.11142",
  "I18n": "static-7.1549",
  "jasmine-immutable": "static-1.2737",
  "jasmine-runner": "static-1.6175",
  "lodash": "static-1.3",
  "quartz": "static-1.6606",
  "react": "static-7.176",
  "react-dlb": "static-1.70",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16352",
  "reporting-data": "static-1.66200",
  "reporting-testing-lib": "static-1.8133",
  "reporting-visualizations": "static-1.58276",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4463",
  "webpack-env": "static-1.54",
  "atom": "static-1.4790",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2185",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90919",
  "cssUtils": "static-1.708",
  "customer-data-filters-ui": "static-1.38614",
  "customer-data-objects": "static-1.7334",
  "customer-data-property-utils": "static-1.7789",
  "data-fetching-client": "static-1.9395",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4252",
  "flux-actions": "static-1.299",
  "FormsCommonComponents": "static-1.85093",
  "FormUrlGenerator": "static-2.4449",
  "foundations-components": "static-1.7358",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3873",
  "HubStyle": "static-2.11450",
  "icons": "static-2.615",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6863",
  "metrics-js": "static-1.9346",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3578",
  "property-translator": "static-1.5132",
  "quartz-config": "static-1.384",
  "quartz-core": "static-1.5825",
  "quick-fetch": "static-1.3655",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5102",
  "react-virtualized": "static-2.93",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7880",
  "reference-resolvers-lite": "static-1.7808",
  "report-customization-components": "static-1.12285",
  "reporting-enablement": "static-1.21826",
  "reporting-reports": "static-1.65878",
  "reporting-snowflake": "static-1.54818",
  "reporting-ui-components": "static-2.63472",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4326",
  "sales-content-partitioning": "static-1.8653",
  "SalesContentIndexUI": "static-3.8782",
  "sanitize": "static-1.4193",
  "sanitize-text": "static-1.7858",
  "self-service-api": "static-1.9946",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1464",
  "signup-constants": "static-1.18245",
  "signup-ui-lego-core": "static-1.20255",
  "signup-ui-url-generator": "static-2.7753",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.482",
  "superstore": "static-1.4491",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10714",
  "ui-addon-i18n": "static-1.10847",
  "ui-addon-react-router-dom": "static-1.9265",
  "ui-addon-upgrades": "static-9.17478",
  "ui-asset-management-lib": "static-1.10597",
  "ui-images": "static-2.1068",
  "UIComponents": "static-3.8089",
  "usage-tracker": "static-1.7053",
  "usage-tracker-container": "static-1.7043",
  "usage-tracker-core": "static-1.6903",
  "usage-tracker-public": "static-1.6864",
  "viral-links-lib": "static-1.6743",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3154",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2883",
  "quartz-webpack": "static-1.2830",
  "ai-components-ui-library": "static-1.8153",
  "amplitude-session-replay-browser": "static-1.54",
  "foundations-assets": "static-1.4550",
  "foundations-theming": "static-1.4123",
  "quartz-auth": "static-1.281",
  "usage-tracker-session-replay": "static-1.4739",
  "foundations-theming-base": "static-1.3108",
  "HeadJS": "static-2.696",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2814",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4050",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7643",
  "graphql": "static-1.76",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3386",
  "persist-promise": "static-1.3406",
  "reporting-client-types": "static-1.2356",
  "hs-story-utils": "static-1.9145",
  "react-flip-move": "static-1.64",
  "hub-http-shared-msw-handlers": "static-1.9277",
  "hubspotter-http": "static-1.4405",
  "sassPrefix": "static-1.150",
  "conversations-skeleton-state": "static-1.6969",
  "crm-message-bus": "static-1.42136",
  "customer-data-filters-ui-msw-helpers": "static-1.21048",
  "customer-data-objects-ui-components": "static-1.12721",
  "customer-data-reference-ui-components": "static-1.12858",
  "customer-data-ui-utilities": "static-1.9544",
  "framework-builder-read-service-client": "static-1.3773",
  "framework-data-schema-quick-fetch": "static-1.6492",
  "framework-data-schema-resolvers": "static-1.6587",
  "inbound-db-properties-service-client": "static-1.3605",
  "multi-account-reference-resolvers": "static-1.687",
  "onboarding-tours": "static-1.16159",
  "reporting-datasets-permissions-lib": "static-1.12821",
  "ui-addon-teams": "static-1.21125",
  "apollo-stack-hubspot": "static-3.80",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67407",
  "customer-data-properties": "static-1.50554",
  "forms-ai-lib": "static-1.3875",
  "forms-utils-lib": "static-1.12028",
  "foundations-components-test-utils": "static-1.4841",
  "react-dnd-compat": "static-1.4342",
  "react-tinymce": "static-1.54427",
  "tinymce-config": "static-2.53553",
  "ui-gdpr-components": "static-1.10064",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3627",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1005",
  "ui-fonts": "static-1.404",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.777",
  "mobile-manifest-mixins": "static-1.469",
  "quartz-head": "static-1.271",
  "quartz-i18n": "static-1.281",
  "quartz-routing": "static-1.36",
  "quartz-test": "static-1.281",
  "batch-promise": "static-1.1249",
  "external-options-client-types": "static-1.3909",
  "react-colorpicker": "static-2.9931",
  "copilot-toolkit": "static-1.10342",
  "data-quality-ui-library": "static-1.12148",
  "html-to-image": "static-1.48",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40461",
  "reporting-insights-lib": "static-1.952",
  "reporting-plugins": "static-1.9884",
  "ui-addon-draggable-compat": "static-2.3972",
  "ui-addon-opt": "static-4.8107",
  "ui-shepherd-react": "static-3.9862",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24518",
  "hubspot-apollo-client": "static-1.4598",
  "sales-templates-service-types-lib": "static-1.3919",
  "ui-business-units-lib": "static-1.8740",
  "merchandise-lib": "static-1.255",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5355",
  "salesImages": "static-1.519",
  "ts-schema": "static-1.3830",
  "upgrade-management-service-types": "static-1.4226",
  "timezone-utils": "static-2.4962",
  "bender-build-tools": "static-1.2832",
  "chatspot-core": "static-1.20045",
  "chirp-fetch": "static-1.1600",
  "bend-plugin-foundations-theming": "static-1.2606",
  "stylex": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.9275",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3549",
  "crm-pipelines-api-client-types": "static-1.3891",
  "multi-currency-client-types": "static-1.3444",
  "getting-started-shared-tasks": "static-1.17677",
  "growth-data-modal": "static-1.5052",
  "growth-onboarding-confetti": "static-1.2770",
  "growth-onboarding-next-action-utils": "static-1.1213",
  "navigation-components": "static-1.17049",
  "onboarding-tours-client": "static-1.4373",
  "onboarding-tours-utils": "static-1.225",
  "ui-shepherd-tracker": "static-1.7243",
  "ui-universal-auth": "static-1.8592",
  "user-context": "static-1.4813",
  "cms-field-types": "static-1.4525",
  "content-icons-ui": "static-1.2127",
  "integrations-lib": "static-1.15182",
  "calling-global-api": "static-1.63420",
  "calling-internal-common": "static-1.31007",
  "calling-lifecycle-internal": "static-1.64802",
  "calling-lifecycle-messages": "static-1.57096",
  "commerce-products-lib": "static-1.8618",
  "crm-links": "static-1.5970",
  "file-manager-components": "static-1.22671",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.379",
  "inbounddb-objects-service-types": "static-1.3976",
  "meetings-icalendar-utils-lib": "static-1.353",
  "object-builder-ui-client": "static-1.47736",
  "pipeline-validation-client-types": "static-1.3713",
  "property-value-citations": "static-1.1168",
  "pulse": "static-1.213",
  "smart-property-lib": "static-1.5637",
  "tiered-pricing": "static-1.708",
  "ui-addon-iframeable": "static-1.8740",
  "final-form": "static-1.64",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19328",
  "tinymce-themes": "static-1.55523",
  "data-token-picker": "static-1.15924",
  "hub-http-contrib": "static-1.2763",
  "interframe": "static-3.4510",
  "tinymce-data": "static-1.39638",
  "tinymce-plugins": "static-1.56667",
  "ui-addon-sales-email": "static-1.4932",
  "magpie-lib": "static-1.5294",
  "magpie-types": "static-1.4754",
  "simple-logging-lib": "static-1.2769",
  "content-assistance-lib": "static-1.7336",
  "dashboard-lib": "static-1.80327",
  "ExportDialog": "static-6.10107",
  "hubspot-prosemirror": "static-1.17394",
  "hubspot-prosemirror-plugins": "static-1.17386",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8408",
  "campaign-roi-lib": "static-1.8060",
  "feedback-loader": "static-1.28715",
  "commerce-analytics-service-client": "static-1.3408",
  "onboarding-scopes": "static-1.6162",
  "apollo-link-hub-http": "static-2.4367",
  "hubspot-apollo-cache": "static-1.57",
  "growth-monetization-service-types": "static-1.4242",
  "nav-client-types": "static-1.2051",
  "purchase-motions-api": "static-1.5358",
  "trials-service-types": "static-1.3643",
  "chatspot-client-types": "static-1.10376",
  "idb-keyval": "static-1.38",
  "reactive-lib": "static-1.444",
  "getting-started-shared-tasks-store": "static-1.16795",
  "integrations-error-boundary-lib": "static-1.12597",
  "integrations-tracking-lib": "static-1.5302",
  "native-integrations-shared-strings": "static-1.7507",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10091",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31013",
  "shared-worker-versioning": "static-1.10736",
  "calling-usage-tracker": "static-1.6257",
  "calling-orchestration-shared-library": "static-1.34576",
  "customer-data-tracking": "static-1.6581",
  "products-iframe-lib": "static-1.7131",
  "products-ui-components-shared-msw-handlers": "static-1.9659",
  "location-customization-utils-lib": "static-1.8325",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3874",
  "video-components-external": "static-1.10334",
  "video-data-lib": "static-1.33992",
  "directed-graph": "static-1.655",
  "event-emitter": "static-1.644",
  "breeze-intelligence-kit": "static-1.5206",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9360",
  "fsm": "static-1.3449",
  "policy-lib": "static-1.6519",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9423",
  "navigation-messaging": "static-1.6376",
  "FileManagerLib": "static-1.38311",
  "NamespacedHubStyle": "static-2.8824",
  "FileManagerCore": "static-1.38170",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11897",
  "layout-dnd-utils": "static-1.10872",
  "react-codemirror": "static-1.10324",
  "ui-addon-emoji-picker": "static-1.9608",
  "ui-brand-identity-lib": "static-1.13504",
  "ui-addon-video-player": "static-1.8432",
  "ui-coaching-tips": "static-1.27750",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8284",
  "payment-link-components": "static-1.22726",
  "EmailSignatureEditor": "static-1.23797",
  "eligibility-engine-service-types": "static-1.2924",
  "universal-page-editor-lib": "static-1.2714",
  "calling-orchestration-schema": "static-1.34801",
  "sales-views-client-types": "static-1.4012",
  "crm-record-cards-service-types": "static-1.3377",
  "content-media-composition-data-lib": "static-1.11169",
  "content-media-compositions": "static-2.15176",
  "media-bridge-lib": "static-1.18446",
  "trellis-story-utils": "static-1.4240",
  "storybook-react": "static-1.27",
  "audio-components": "static-1.5500",
  "FileManagerImages": "static-1.35822",
  "video-components": "static-1.12337",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4252",
  "video-embed": "static-1.34826",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67482",
  "layout-data-lib": "static-1.9197",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6304",
  "commerce-tours-lib": "static-1.5601",
  "growth-onboarding-reliability": "static-1.4807",
  "sales-checkout-service-client": "static-1.3420",
  "draft-convert": "static-2.31",
  "draft-extend": "static-3.69",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21164",
  "sales-email-signature-service-client": "static-1.3561",
  "hls.js": "static-1.33",
  "social-insights-client-types": "static-1.21128",
  "outpost": "static-1.3930",
  "advanced-menus-core": "static-1.14688",
  "advanced-menus-lib": "static-1.11677",
  "ui-memberships-settings-lib": "static-1.33233",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14687",
  "simple-menus-lib": "static-1.16204"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33798",
  "client-types": "/client-types/static-1.443",
  "documents-lib": "/documents-lib/static-1.33803",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1839",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.98",
  "hs-promise-utils": "/hs-promise-utils/static-1.5309",
  "hs-test-utils": "/hs-test-utils/static-1.7703",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "HubStyleTokens": "/HubStyleTokens/static-2.11142",
  "I18n": "/I18n/static-7.1549",
  "jasmine-immutable": "/jasmine-immutable/static-1.2737",
  "jasmine-runner": "/jasmine-runner/static-1.6175",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6606",
  "react": "/react/static-7.176",
  "react-dlb": "/react-dlb/static-1.70",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16352",
  "reporting-data": "/reporting-data/static-1.66200",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8133",
  "reporting-visualizations": "/reporting-visualizations/static-1.58276",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4463",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4790",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2185",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90919",
  "cssUtils": "/cssUtils/static-1.708",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38614",
  "customer-data-objects": "/customer-data-objects/static-1.7334",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7789",
  "data-fetching-client": "/data-fetching-client/static-1.9395",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4252",
  "flux-actions": "/flux-actions/static-1.299",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85093",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4449",
  "foundations-components": "/foundations-components/static-1.7358",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "HubStyle": "/HubStyle/static-2.11450",
  "icons": "/icons/static-2.615",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6863",
  "metrics-js": "/metrics-js/static-1.9346",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3578",
  "property-translator": "/property-translator/static-1.5132",
  "quartz-config": "/quartz-config/static-1.384",
  "quartz-core": "/quartz-core/static-1.5825",
  "quick-fetch": "/quick-fetch/static-1.3655",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5102",
  "react-virtualized": "/react-virtualized/static-2.93",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7880",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7808",
  "report-customization-components": "/report-customization-components/static-1.12285",
  "reporting-enablement": "/reporting-enablement/static-1.21826",
  "reporting-reports": "/reporting-reports/static-1.65878",
  "reporting-snowflake": "/reporting-snowflake/static-1.54818",
  "reporting-ui-components": "/reporting-ui-components/static-2.63472",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4326",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8653",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8782",
  "sanitize": "/sanitize/static-1.4193",
  "sanitize-text": "/sanitize-text/static-1.7858",
  "self-service-api": "/self-service-api/static-1.9946",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1464",
  "signup-constants": "/signup-constants/static-1.18245",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20255",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7753",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "superstore": "/superstore/static-1.4491",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10714",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10847",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9265",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17478",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10597",
  "ui-images": "/ui-images/static-2.1068",
  "UIComponents": "/UIComponents/static-3.8089",
  "usage-tracker": "/usage-tracker/static-1.7053",
  "usage-tracker-container": "/usage-tracker-container/static-1.7043",
  "usage-tracker-core": "/usage-tracker-core/static-1.6903",
  "usage-tracker-public": "/usage-tracker-public/static-1.6864",
  "viral-links-lib": "/viral-links-lib/static-1.6743",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3154",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2883",
  "quartz-webpack": "/quartz-webpack/static-1.2830",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8153",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4550",
  "foundations-theming": "/foundations-theming/static-1.4123",
  "quartz-auth": "/quartz-auth/static-1.281",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4739",
  "foundations-theming-base": "/foundations-theming-base/static-1.3108",
  "HeadJS": "/HeadJS/static-2.696",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2814",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4050",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7643",
  "graphql": "/graphql/static-1.76",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3386",
  "persist-promise": "/persist-promise/static-1.3406",
  "reporting-client-types": "/reporting-client-types/static-1.2356",
  "hs-story-utils": "/hs-story-utils/static-1.9145",
  "react-flip-move": "/react-flip-move/static-1.64",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9277",
  "hubspotter-http": "/hubspotter-http/static-1.4405",
  "sassPrefix": "/sassPrefix/static-1.150",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6969",
  "crm-message-bus": "/crm-message-bus/static-1.42136",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21048",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12721",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12858",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9544",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3773",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6492",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6587",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3605",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.687",
  "onboarding-tours": "/onboarding-tours/static-1.16159",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12821",
  "ui-addon-teams": "/ui-addon-teams/static-1.21125",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67407",
  "customer-data-properties": "/customer-data-properties/static-1.50554",
  "forms-ai-lib": "/forms-ai-lib/static-1.3875",
  "forms-utils-lib": "/forms-utils-lib/static-1.12028",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4841",
  "react-dnd-compat": "/react-dnd-compat/static-1.4342",
  "react-tinymce": "/react-tinymce/static-1.54427",
  "tinymce-config": "/tinymce-config/static-2.53553",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10064",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3627",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1005",
  "ui-fonts": "/ui-fonts/static-1.404",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.777",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.469",
  "quartz-head": "/quartz-head/static-1.271",
  "quartz-i18n": "/quartz-i18n/static-1.281",
  "quartz-routing": "/quartz-routing/static-1.36",
  "quartz-test": "/quartz-test/static-1.281",
  "batch-promise": "/batch-promise/static-1.1249",
  "external-options-client-types": "/external-options-client-types/static-1.3909",
  "react-colorpicker": "/react-colorpicker/static-2.9931",
  "copilot-toolkit": "/copilot-toolkit/static-1.10342",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12148",
  "html-to-image": "/html-to-image/static-1.48",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40461",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.952",
  "reporting-plugins": "/reporting-plugins/static-1.9884",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3972",
  "ui-addon-opt": "/ui-addon-opt/static-4.8107",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9862",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24518",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4598",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3919",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8740",
  "merchandise-lib": "/merchandise-lib/static-1.255",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5355",
  "salesImages": "/salesImages/static-1.519",
  "ts-schema": "/ts-schema/static-1.3830",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4226",
  "timezone-utils": "/timezone-utils/static-2.4962",
  "bender-build-tools": "/bender-build-tools/static-1.2832",
  "chatspot-core": "/chatspot-core/static-1.20045",
  "chirp-fetch": "/chirp-fetch/static-1.1600",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2606",
  "stylex": "/stylex/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9275",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3549",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3891",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3444",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17677",
  "growth-data-modal": "/growth-data-modal/static-1.5052",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2770",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1213",
  "navigation-components": "/navigation-components/static-1.17049",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4373",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.225",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7243",
  "ui-universal-auth": "/ui-universal-auth/static-1.8592",
  "user-context": "/user-context/static-1.4813",
  "cms-field-types": "/cms-field-types/static-1.4525",
  "content-icons-ui": "/content-icons-ui/static-1.2127",
  "integrations-lib": "/integrations-lib/static-1.15182",
  "calling-global-api": "/calling-global-api/static-1.63420",
  "calling-internal-common": "/calling-internal-common/static-1.31007",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64802",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57096",
  "commerce-products-lib": "/commerce-products-lib/static-1.8618",
  "crm-links": "/crm-links/static-1.5970",
  "file-manager-components": "/file-manager-components/static-1.22671",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.379",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3976",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.353",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47736",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3713",
  "property-value-citations": "/property-value-citations/static-1.1168",
  "pulse": "/pulse/static-1.213",
  "smart-property-lib": "/smart-property-lib/static-1.5637",
  "tiered-pricing": "/tiered-pricing/static-1.708",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8740",
  "final-form": "/final-form/static-1.64",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19328",
  "tinymce-themes": "/tinymce-themes/static-1.55523",
  "data-token-picker": "/data-token-picker/static-1.15924",
  "hub-http-contrib": "/hub-http-contrib/static-1.2763",
  "interframe": "/interframe/static-3.4510",
  "tinymce-data": "/tinymce-data/static-1.39638",
  "tinymce-plugins": "/tinymce-plugins/static-1.56667",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4932",
  "magpie-lib": "/magpie-lib/static-1.5294",
  "magpie-types": "/magpie-types/static-1.4754",
  "simple-logging-lib": "/simple-logging-lib/static-1.2769",
  "content-assistance-lib": "/content-assistance-lib/static-1.7336",
  "dashboard-lib": "/dashboard-lib/static-1.80327",
  "ExportDialog": "/ExportDialog/static-6.10107",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17394",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17386",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8408",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8060",
  "feedback-loader": "/feedback-loader/static-1.28715",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3408",
  "onboarding-scopes": "/onboarding-scopes/static-1.6162",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4367",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.57",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4242",
  "nav-client-types": "/nav-client-types/static-1.2051",
  "purchase-motions-api": "/purchase-motions-api/static-1.5358",
  "trials-service-types": "/trials-service-types/static-1.3643",
  "chatspot-client-types": "/chatspot-client-types/static-1.10376",
  "idb-keyval": "/idb-keyval/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.444",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16795",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12597",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5302",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7507",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10091",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31013",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10736",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6257",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34576",
  "customer-data-tracking": "/customer-data-tracking/static-1.6581",
  "products-iframe-lib": "/products-iframe-lib/static-1.7131",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9659",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8325",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3874",
  "video-components-external": "/video-components-external/static-1.10334",
  "video-data-lib": "/video-data-lib/static-1.33992",
  "directed-graph": "/directed-graph/static-1.655",
  "event-emitter": "/event-emitter/static-1.644",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5206",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9360",
  "fsm": "/fsm/static-1.3449",
  "policy-lib": "/policy-lib/static-1.6519",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9423",
  "navigation-messaging": "/navigation-messaging/static-1.6376",
  "FileManagerLib": "/FileManagerLib/static-1.38311",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8824",
  "FileManagerCore": "/FileManagerCore/static-1.38170",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11897",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10872",
  "react-codemirror": "/react-codemirror/static-1.10324",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9608",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13504",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8432",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27750",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8284",
  "payment-link-components": "/payment-link-components/static-1.22726",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23797",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2924",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2714",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34801",
  "sales-views-client-types": "/sales-views-client-types/static-1.4012",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3377",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11169",
  "content-media-compositions": "/content-media-compositions/static-2.15176",
  "media-bridge-lib": "/media-bridge-lib/static-1.18446",
  "trellis-story-utils": "/trellis-story-utils/static-1.4240",
  "storybook-react": "/storybook-react/static-1.27",
  "audio-components": "/audio-components/static-1.5500",
  "FileManagerImages": "/FileManagerImages/static-1.35822",
  "video-components": "/video-components/static-1.12337",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4252",
  "video-embed": "/video-embed/static-1.34826",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67482",
  "layout-data-lib": "/layout-data-lib/static-1.9197",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6304",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5601",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4807",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3420",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-3.69",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21164",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3561",
  "hls.js": "/hls.js/static-1.33",
  "social-insights-client-types": "/social-insights-client-types/static-1.21128",
  "outpost": "/outpost/static-1.3930",
  "advanced-menus-core": "/advanced-menus-core/static-1.14688",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11677",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33233",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14687",
  "simple-menus-lib": "/simple-menus-lib/static-1.16204"
}
};
